<template>
  <button class="resend-option" type="button" @click="$emit('click')">
    <img v-if="icon" class="resend-icon" :src="icon"/>
    <span class="resend-text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'ResendCodeOption',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.resend-option {
  display: flex;
  direction: rtl;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: fit-content;
  max-width: 100%;
  height: 42px;
  margin: 20px auto 0;
  padding: 0 20px;
  background-color: $riseup_white;
  border: 1px solid #d9d9d9;
  border-radius: 35px;
  color: $riseup_blue;
  font-family: SimplerPro, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  text-align: right;

  &:active {
    color: $riseup_dark_blue;
  }

  .resend-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
}
</style>
